import React, { useState, useEffect } from "react";
import withDashboard from "../../HOC/withDashboard";
import BackgroundImage from "../../assets/profilebackground.jpeg";
import "../Profile/index.css";
import { Button, TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
    getGiftCardTransactionById,
    updateGiftCardTransaction,
} from "../../services/GiftCardServices";
import Loader from "../../components/Loader";
import { useNavigate, useParams } from "react-router-dom";
import { getFileUrl } from "../../services/CommonService";

const GiftCardTransactionsForm = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();
    const [isLoading, setIsLoading] = React.useState(false);
    const [dataForm, setDataForm] = React.useState({});

    const isEdit = Boolean(id);
    const [form, setForm] = useState({
        finalReceivedNaira: "",
        rejectionNote: "",
        action: "",
    });
    const [errors, setErrors] = useState({
        finalReceivedNaira: false,
        rejectionNote: false,
        action: false,
    });

    useEffect(() => {
        getGiftCardTransactions(id);
    }, [id]);

    const getGiftCardTransactions = (id) => {
        setIsLoading(true);
        dispatch(getGiftCardTransactionById(id))
            .then((res) => {
                console.log(res?.data?.data);

                setDataForm(res?.data?.data);
                if (
                    res?.data?.data &&
                    res.data.data.receivableNaira &&
                    res.data.data.status == "pending"
                ) {
                    setForm({
                        ...form,
                        finalReceivedNaira: res.data.data.receivableNaira || 0,
                    });
                }
                setIsLoading(false);
            })
            .catch(({ message, errorData, statusCode }) => {
                console.error("Error fetching gift card categories:", message);
                setIsLoading(false);
            });
    };

    const onChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
        setErrors({ ...errors, [e.target.name]: false });
    };

    const onSubmit = () => {
        let newErrors = "";
        if (form.action && form.action == "reject") {
            newErrors = {
                finalReceivedNaira: !form.finalReceivedNaira,
                rejectionNote: !form.rejectionNote,
                action: !form.action,
            };
        } else {
            newErrors = {
                finalReceivedNaira: !form.finalReceivedNaira,
                action: !form.action,
            };
        }

        setErrors(newErrors);
        if (Object.values(newErrors).some((v) => v)) return;
        if (isEdit) {
            setIsLoading(true);
            dispatch(updateGiftCardTransaction(id, form))
                .then((res) => {
                    setIsLoading(false);
                    navigate("/gift-card-transactions");
                })
                .catch(({ message, errorData, statusCode }) => {
                    console.error(
                        "Error updating gift card transaction:",
                        message
                    );
                    setIsLoading(false);
                });
        }
    };

    return (
        <div className="profile-container">
            <div className="profile-backgroundImage-container">
                <img
                    src={BackgroundImage}
                    className="profile-backgroundImage"
                    alt="background.png"
                />
            </div>
            <div className="profile-card-container">
                <div className="profile-card">
                    <h2 style={{ marginBottom: 24 }}>
                        {isEdit ? "Edit" : "Add"} Card Transaction Data
                    </h2>
                    <div className="profile-inputs-container">
                        <div className="profile-input-row">
                            <table className="profile-table">
                                <tbody>
                                    <tr>
                                        <th>ID</th>
                                        <td>{dataForm._id || "N/A"}</td>
                                    </tr>
                                    <tr>
                                        <th>Transaction Id</th>
                                        <td>
                                            {dataForm.transactionId || "N/A"}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Card Categori Name</th>
                                        <td>
                                            {dataForm?.giftCategoryId?.name ||
                                                "N/A"}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Card Name</th>
                                        <td>
                                            {dataForm?.giftCardId?.name ||
                                                "N/A"}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>User</th>
                                        <td>
                                            {dataForm?.userId?.name || "N/A"} (
                                            {dataForm?.userId?.email || "N/A"})
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Amount</th>
                                        <td>{dataForm.amount || "N/A"}</td>
                                    </tr>
                                    <tr>
                                        <th>Api Rate</th>
                                        <td>
                                            {dataForm.originalRate || "N/A"}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>System Rate</th>
                                        <td>
                                            {dataForm.customerRate || "N/A"}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Received Amount</th>
                                        <td>
                                            {dataForm.receivableNaira || "N/A"}
                                        </td>
                                    </tr>
                                    {dataForm.status &&
                                    dataForm.status != "pending" ? (
                                        <tr>
                                            <th>Final Received Amount</th>
                                            <td>
                                                {dataForm.finalReceivedNaira ||
                                                    "N/A"}
                                            </td>
                                        </tr>
                                    ) : (
                                        <></>
                                    )}
                                    {dataForm.status &&
                                    dataForm.status == "rejected" ? (
                                        <tr>
                                            <th>Reject Note</th>
                                            <td>
                                                {dataForm.rejectionNote ||
                                                    "N/A"}
                                            </td>
                                        </tr>
                                    ) : (
                                        <></>
                                    )}
                                    <tr>
                                        <th>Gift Card Image</th>
                                        <td>
                                            {dataForm.giftCardImage &&
                                            dataForm.giftCardImage !== "" ? (
                                                <div className="user-image size-[50px] rounded-full ">
                                                    <img
                                                        src={getFileUrl(
                                                            dataForm.giftCardImage,
                                                            "couponImage"
                                                        )}
                                                        alt=""
                                                    />
                                                </div>
                                            ) : (
                                                <></>
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Status</th>
                                        <td>
                                            {dataForm.status &&
                                            dataForm.status == "approved"
                                                ? "Approved"
                                                : dataForm.status &&
                                                  dataForm.status == "rejected"
                                                ? "Rejected"
                                                : "Pending"}
                                        </td>
                                    </tr>
                                    {dataForm.status &&
                                    dataForm.status == "pending" ? (
                                        <>
                                            <tr>
                                                <td colSpan={2}>
                                                    <div className="profile-input-item">
                                                        <div className="profile-input-container">
                                                            <TextField
                                                                label="Received Naira"
                                                                variant="outlined"
                                                                className="w-100"
                                                                name="finalReceivedNaira"
                                                                onChange={
                                                                    onChange
                                                                }
                                                                value={
                                                                    form.finalReceivedNaira
                                                                }
                                                                error={
                                                                    errors.finalReceivedNaira
                                                                }
                                                                helperText={
                                                                    errors.finalReceivedNaira
                                                                        ? "Received Naira is required"
                                                                        : ""
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan={2}>
                                                    <div className="profile-input-item">
                                                        <div className="profile-input-container">
                                                            <TextField
                                                                select
                                                                label="Action"
                                                                variant="outlined"
                                                                className="w-100"
                                                                name="action"
                                                                onChange={
                                                                    onChange
                                                                }
                                                                value={
                                                                    form.action
                                                                }
                                                                error={
                                                                    errors.action
                                                                }
                                                                helperText={
                                                                    errors.action
                                                                        ? "Action is required"
                                                                        : ""
                                                                }
                                                                SelectProps={{
                                                                    native: true,
                                                                }}>
                                                                <option value="">
                                                                    Select
                                                                    Action
                                                                </option>
                                                                <option value="approve">
                                                                    Approve
                                                                </option>
                                                                <option value="reject">
                                                                    Reject
                                                                </option>
                                                            </TextField>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                            {form.action &&
                                            form.action == "reject" ? (
                                                <tr>
                                                    <td colSpan={2}>
                                                        <div className="profile-input-item">
                                                            <div className="profile-input-container">
                                                                <TextField
                                                                    label="Rejection Note"
                                                                    variant="outlined"
                                                                    className="w-100"
                                                                    name="rejectionNote"
                                                                    onChange={
                                                                        onChange
                                                                    }
                                                                    value={
                                                                        form.rejectionNote
                                                                    }
                                                                    error={
                                                                        errors.rejectionNote
                                                                    }
                                                                    helperText={
                                                                        errors.rejectionNote
                                                                            ? "Rejection Note is required"
                                                                            : ""
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ) : (
                                                <></>
                                            )}
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <div className="profile-input-btn-container">
                            {dataForm.status && dataForm.status == "pending" ? (
                                <Button
                                    variant="contained"
                                    className="profile-btn"
                                    onClick={onSubmit}
                                    disabled={isLoading}>
                                    Update
                                </Button>
                            ) : (
                                <></>
                            )}

                            <Button
                                variant="outlined"
                                style={{ marginLeft: 16 }}
                                onClick={() =>
                                    navigate("/gift-card-transactions")
                                }>
                                Cancel
                            </Button>
                        </div>
                    </div>
                    {isLoading && <Loader />}
                </div>
            </div>
        </div>
    );
};

export default withDashboard(GiftCardTransactionsForm);
